import { render, staticRenderFns } from "./CiImageModal.vue?vue&type=template&id=5563365e&"
import script from "./CiImageModal.vue?vue&type=script&lang=js&"
export * from "./CiImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CiImageModal.vue"
export default component.exports